import { InjectionToken } from '@angular/core';
import { PackageGroupPackageContentType } from '../../../enums/package-group-package-content-type.enum';

export const PACKAGE_GROUP_PACKAGE_CONTENT_TYPE = new InjectionToken<PackageGroupPackageContentType>('PACKAGE_GROUP_PACKAGE_CONTENT_TYPE');
